import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, take } from 'rxjs';
import { AccountService } from '@core/services/account/account.service';
import { AppRoutePaths } from '@core/types/app-route-paths';
import type { User } from '@core/types/User';
import type { AuthState } from '@core/services/account/account.types';

const createPersonRequiredGuard = (
  shouldRedirect: (authState: AuthState, user: User | null) => boolean,
  redirectPath: AppRoutePaths,
): CanActivateFn => {
  return () => {
    const accountService = inject(AccountService);
    const router = inject(Router);

    return combineLatest([
      accountService.authState$,
      accountService.currentUser$,
    ]).pipe(
      filter(([authState]) => authState !== 'unknown'),
      take(1),
      map(([authState, user]) =>
        shouldRedirect(authState, user)
          ? router.createUrlTree([redirectPath])
          : true,
      ),
    );
  };
};

export const personRequiredGuard = createPersonRequiredGuard(
  (authState, user) => authState === 'authenticated' && !user?.personId?.id,
  AppRoutePaths.PersonRequired,
);

export const personRequiredPageGuard = createPersonRequiredGuard(
  (authState, user) => authState === 'authenticated' && !!user?.personId?.id,
  AppRoutePaths.Requests,
);
